export default "/_next/static/images/header-bg-dc8aea629667cb2db8162b9068765cad.png";